/* eslint-disable prefer-destructuring */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import TableMC from '../../components/TableMC';
import usePagination from '../../../hooks/usePagination';
import RemindersModelMC from '../../models/RemindersModelMC';
import { GLOBAL_STATUS } from '../../../constants/AppConstants';
import { SIDEBAR_ACTIONS } from '../../../constants/actionsConstants';
import TitleMC from '../../components/TitleMC';
import { formatToJson } from '../../../util/serializeQueryParamsUtils';

const RemindersListModuleMC = () => {
  const MESSAGE_LIMIT = 0;
  const { t } = useTranslation('RemindersScreenMC');
  const [catalogs, setCatalogs] = React.useState(null);
  const dispatch = useDispatch();

  const getCatalogs = async () => {
    RemindersModelMC.getCatalogs().then((data) => {
      setCatalogs(data);
    });
  };

  const serializeParams = (params) => {
    const res = formatToJson(params);
    const newParams = {
      ...res
    };

    if (res.date && !isEmpty(res.date)) {
      newParams.start_date = res.date.startDate.split('T')[0];
      newParams.end_date = res.date.endDate.split('T')[0];
    }

    delete newParams.date;
    return newParams;
  };

  const {
    data,
    paginationComponent,
    filtersComponent,
    loading,
    refetch
  } = usePagination({
    formatParams: serializeParams,
    modelService: RemindersModelMC.get,
    filters: [
      {
        type: 'search',
        key: 'search',
        label: t('find_by_name_or_number'),
        containerClassName: 'tw-w-96'
      }
    ],
    asideFilters: [
      {
        type: 'select',
        key: 'customer_agent_id_eq',
        label: t('agent'),
        containerClassName: 'tw-pr-0',
        options: catalogs?.retailer_users || []
      },
      {
        type: 'date-range',
        key: 'date',
        label: t('date'),
        containerClassName: 'tw-pr-0'
      },
      {
        type: 'select',
        key: 'status_eq',
        label: t('status'),
        containerClassName: 'tw-pr-0',
        options: (catalogs?.status || []).map((status) => {
          const statusLabel = `status_values.${status.label}`;
          return {
            id: status.id,
            label: t(statusLabel)
          };
        })
      }
    ]
  });

  const tableRemindersHeaders = [
    { key: 'client', label: t('client') },
    { key: 'message', label: t('message') },
    { key: 'createdBy', label: t('create_by') },
    { key: 'sendDate', label: t('send_date') },
    { key: 'status', label: t('status') }
  ];

  const handleViewMore = (messageId) => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'MessageDetailSidebar',
        props: {
          messageId
        }
      }
    });
  };

  const handleCancelReminders = (remindersWebId) => {
    const confirmCancel = window.confirm('¿Estás seguro de cancelar este mensaje programado?');
    if (confirmCancel) {
      RemindersModelMC.cancel(remindersWebId).then(() => {
        refetch();
      });
    }
  };

  const getRemindersRows = () => (data.reminders || []).map((reminders) => {
    const clientContent = (
      <span className="tw-flex tw-flex-col">
        <span>{reminders.customer?.name}</span>
        <span>
          {reminders.customer?.phone}
        </span>
      </span>
    );

    const isPendingOrProcessing = [
      GLOBAL_STATUS.pending.value,
      GLOBAL_STATUS.processing.value,
      GLOBAL_STATUS.in_process.value,
      GLOBAL_STATUS.scheduled.value
    ].includes(reminders.message.status);
    const statusType = isPendingOrProcessing ? 'status_action' : 'status';
    const statusAction = isPendingOrProcessing
      ? [
        {
          label: t('cancel'),
          onClick: () => handleCancelReminders(reminders.message.web_id)
        }
      ]
      : null;

    return {
      client: {
        type: 'custom-component',
        value: clientContent
      },
      message: {
        type: 'view_more',
        value: '',
        className: 'tw-max-w-[180px]',
        limit: MESSAGE_LIMIT,
        onClick: () => handleViewMore(reminders.message?.id)
      },
      createdBy: { type: 'text', value: reminders.sender?.name },
      sendDate: { type: 'status-label', value: reminders.message?.send_at },
      status: { type: statusType, value: reminders.message.status, actions: statusAction }
    };
  });

  React.useEffect(() => {
    getCatalogs();
  }, []);

  return (
    <div className="tw-wrapper">
      <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-pb-5">
        <TitleMC text={t('title')} variant="H5" textClassName="tw-font-semibold" />
        {filtersComponent}
      </div>

      <TableMC
        headers={tableRemindersHeaders}
        data={getRemindersRows()}
        borderAll
        loading={loading}
      />
      {data?.pages > 1 && (
        <div className="tw-pt-4">
          {paginationComponent}
        </div>
      )}
    </div>
  );
};

export default RemindersListModuleMC;
